import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import React from "react";
import { IT_SHOP_URL } from "@/config";

/**
 * Catch-all route for unmatched paths — renders the 404 UI.
 */
const NotFoundPage: React.FC = () => {
  return (
    <View padding="4rem 2rem" display="flex" justifyContent="center">
      <Col gridGap="S400" alignItems="center">
        <Text fontSize="T500" fontWeight="bold">
          {getString("notFound.title")}
        </Text>
        <Text fontSize="T200" color="neutral70">
          {getString("notFound.description")}
        </Text>
        <Button
          variant={ButtonVariant.Primary}
          onClick={() => {
            window.location.href = IT_SHOP_URL;
          }}
          data-testid="not-found-home-button"
        >
          {getString("notFound.returnHomeButton")}
        </Button>
      </Col>
    </View>
  );
};

export default NotFoundPage;
